export const PARAM_PHONE_NUMBER = 'sdkPhoneNumber'

// Query params
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp'
export const PARAM_IS_EMBEDDED_VIEW = 'isEmbeddedView'
export const PARAM_SHOW_PHONE_INPUT = 'showPhoneInput'
export const PARAM_SHOW_BANNER_IN_EMBEDDED_VIEW = 'showBannerInEmbeddedView'
export const PARAM_ENABLE_SAFE_HEADER = 'enableSafeHeader'
export const MESSAGE_BACK_TO_HOME_MINI_APP = 'BackToHomeMiniApp'
// Iframe
export const PARAM_IFRAME_URL = 'url'